import * as React from "react";
import styled, { css } from "styled-components";

import { Text } from "src/library/components/Text";

import { IProduct } from "./api/products.api";

interface PartNumberProps {
  product: IProduct;
}
export const PartNumber: React.ReactFCWithChildren<PartNumberProps> = ({ product }) => {
  return (
    <PartNumberWrapper className="part-number-wrapper">
      <Text
        color="secondary"
        weight="bold"
        textTransform="uppercase"
        letterSpacing="big"
        className="part-number"
      >
        {`#${product.partNumber}`}
      </Text>
    </PartNumberWrapper>
  );
};

const PartNumberWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    margin-top: ${theme.spacing.margins.xs};

    .part-number {
      overflow: hidden;
    }
  `}
`;
